import { useEffect, useState } from 'react';

import { getAccountSummary } from 'features/statement/actions';

import { useAppDispatch } from 'hooks';

import { Loading } from 'componets/ui';
import { Income } from './Income';
import { Investment } from './Investment';
import { PrincipalRepayment } from './PrincipalRepayment';
import { DepositWithdrawal } from './DepositWithdrawal';
import { AccountSummaryTable } from './AccountSummaryTable';

import './index.scss';

export const AccountSummary = () => {
	const dispatch = useAppDispatch();

	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		dispatch(getAccountSummary()).finally(() => {
			setIsLoading(false);
		});
	}, [dispatch]);

	if (isLoading) return <Loading />;

	return (
		<div className="accountSummary">
			<div>
				<div className="accountSummary__block">
					<AccountSummaryTable />
				</div>
			</div>

			<div className="accountSummary__row">
				<div className="accountSummary__block">
					<Income />
				</div>
				<div className="accountSummary__block">
					<PrincipalRepayment />
				</div>
			</div>

			<div className="accountSummary__row">
				<div className="accountSummary__block">
					<Investment />
				</div>
				<div className="accountSummary__block ">
					<DepositWithdrawal />
				</div>
			</div>
		</div>
	);
};
